<template>
  <div>
    <hr />
    <div class="row-1">
      <div v-show="configInputs != 0">
        <label class="col-form-label font-weight-bold"> Número RRIM </label>
        <input
          v-model="v$.dados.IGRRIM.$model"
          :class="[
            'form-control',
            {
              error:
                v$.dados.IGRRIM.$model == '' ? true : v$.dados.IGRRIM.$error,
            },
          ]"
          :disabled="configInputs != 0"
        />
        <div
          class="text-red"
          v-if="v$.dados.IGRRIM.$model == '' ? true : v$.dados.IGRRIM.$error"
        >
          O campo RRIM é obrigatório.
        </div>
      </div>
      <div>
        <label class="col-form-label font-weight-bold"> Número Molde </label>
        <input
          @change="mapMoldSap(this.dados.IGMolde)"
          list="listMoldeInfor"
          v-model="v$.dados.IGMolde.$model"
          type="text"
          placeholder="Ex: MD + N°Molde"
          :class="['form-control', { error: v$.dados.IGMolde.$error }]"
          :disabled="configInputs"
        />
        <div v-if="validationMolde === true" class="text-red">
          Molde não encontrado no SAP.
        </div>
        <div class="text-red" v-if="v$.dados.IGMolde.$error">
          O campo Número Molde é obrigatório.
        </div>
        <datalist id="listMoldeInfor">
          <div v-for="(l, index) in listMoldes" :key="index">
            <option :value="l.codigoMolde">
              {{ l.codigoMolde }}
            </option>
          </div>
        </datalist>
      </div>

      <div @keydown.enter.stop class="m-40">
        <label class="col-form-label font-weight-bold"> Cliente *</label>
        <input
          :disabled="configInputs"
          v-model="v$.dados.IGCliente.$model"
          type="text"
          :class="['form-control', { error: v$.dados.IGCliente.$error }]"
        />
        <div class="text-red" v-if="v$.dados.IGCliente.$error">
          O campo Cliente é obrigatório.
        </div>
      </div>
      <div class="m-40 checkbox" v-if="configInputs == 0">
        <input
          v-model="dados.molde_familia"
          type="checkbox"
          placeholder="Produto"
        />
        <label class="col-form-label font-weight-bold"> Molde Familia </label>
      </div>
      <div class="m-40 checkbox" v-else>
        <input
          type="checkbox"
          v-if="dados.molde_familia === 'true'"
          checked
          disabled
        />
        <input type="checkbox" v-else disabled />
        <label class="col-form-label font-weight-bold"> Molde Familia </label>
      </div>
    </div>

    <div class="row-1">
      <div>
        <label class="col-form-label font-weight-bold">
          Número Nota Fiscal
        </label>
        <input
          v-model="dados.IGNF"
          v-maska="[
            '#### #### #### #### #### #### #### #### #### #### ####',
            '',
          ]"
          class="form-control"
          :disabled="configInputs"
        />
        <!-- <div class="text-red" v-if="v$.dados.IGNF.$error">
          O campo Número  Nota Fiscal é obrigatório.
        </div> -->
      </div>

      <div>
        <label class="col-form-label font-weight-bold">
          Código do Molde do Cliente:
        </label>
        <input
          v-model="dados.IGCMC"
          type="text"
          class="form-control"
          :disabled="configInputs"
        />
        <!-- <div class="text-red" v-if="v$.dados.IGCMC.$error">
          O campo Código é obrigatório.
        </div> -->
      </div>

      <div class="m-40">
        <label class="col-form-label font-weight-bold">
          Fabricante do Molde
        </label>
        <input
          v-model="dados.IGFM"
          type="text"
          class="form-control"
          :disabled="configInputs"
        />
        <!-- <div class="text-red" v-if="v$.dados.IGFM.$error">
          O campo Fabricante é obrigatório.
        </div> -->
      </div>
    </div>

    <div class="row-1">
      <div>
        <label class="col-form-label font-weight-bold">
          Emissão de Nota Fiscal
        </label>
        <input
          v-model="dados.IGENF"
          type="date"
          class="form-control"
          :disabled="configInputs"
        />
        <!-- <div class="text-red" v-if="v$.dados.IGENF.$error">
          O campo Emissão de Nota Fiscal é obrigatório.
        </div> -->
      </div>
      <div class="m-20">
        <label class="col-form-label font-weight-bold">
          Data de Chegada do Molde *
        </label>
        <input
          v-model="v$.dados.IGDCM.$model"
          type="date"
          :class="['form-control', { error: v$.dados.IGDCM.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.IGDCM.$error">
          O campo Chegada do Molde é obrigatório.
        </div>
      </div>

      <div class="m-20">
        <label class="col-form-label font-weight-bold"
          >Data de Abertura do Molde *
        </label>
        <input
          v-model="v$.dados.IGDAM.$model"
          type="date"
          :class="['form-control', { error: v$.dados.IGDAM.$error }]"
          :disabled="configInputs"
        />
        <div class="text-red" v-if="v$.dados.IGDAM.$error">
          O campo Abertura do Molde é obrigatório.
        </div>
      </div>

      <div class="m-20">
        <label class="col-form-label font-weight-bold">
          Data de Try-Out do Molde
        </label>
        <input
          v-model="dados.IGDTM"
          type="date"
          class="form-control"
          :disabled="configInputs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { minLength, required } from "@vuelidate/validators";
import dayjs from "dayjs";
import { sap } from "../../../../../../http/index";
import InputI1E from "../../../../../Inputs-defaults/Inp-1-emit.vue";
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";

export default {
  components: { InputI1, InputI1E },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      CavityMolde: Number,
      listMoldes: [],
      rrim: "",
      validationMolde: false,
      dados: {
        IGDTM: "",
        IGDAM: "",
        IGDCM: "",
        IGFM: "",
        IGCMC: "",
        IGENF: "",
        IGNF: "",
        IGCliente: "",
        IGMolde: "",
        IGRRIM: "MD-PADRÃO",
        molde_familia: "false",
      },
    };
  },

  props: {
    configInputs: Number,
    dadosQuery: Object,
  },

  validations() {
    return {
      dados: {
        IGRRIM: {
          required,
          minLength: minLength(4),
        },

        IGMolde: {
          required,
          minLength: minLength(4),
        },

        IGCliente: {
          required,
          minLength: minLength(4),
        },
        // IGNF: {
        //   required,
        //   minLength: minLength(4),
        // },
        IGDCM: {
          required,
          minValue(val) {
            if (new Date(val) >= new Date()) {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                // didOpen: (toast) => {
                //   toast.addEventListener("mouseenter", Swal.stopTimer);
                //   toast.addEventListener("mouseleave", Swal.resumeTimer);
                // },
              });

              Toast.fire({
                icon: "info",
                title: "Data de Chegada de Molde",
                text: "Data maior que a atual",
              });

              return false;
            }
            return true;
          },
        },
        IGDAM: {
          required,
          minValue(val) {
            if (new Date(val) < new Date(this.dados.IGDCM)) {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                // didOpen: (toast) => {
                //   toast.addEventListener("mouseenter", Swal.stopTimer);
                //   toast.addEventListener("mouseleave", Swal.resumeTimer);
                // },
              });

              Toast.fire({
                icon: "info",
                title: "Data de Abertura do Molde",
                text: "Data menor do que a data de chegada do molde.",
              });

              return false;
            }
            return true;
          },
        },
        // IGDTM: {
        //   required,
        //   minValue(val) {
        //     if (new Date(val) < new Date(this.dados.IGDAM)) {
        //       const Toast = this.$swal.mixin({
        //         toast: true,
        //         position: "top-end",
        //         showConfirmButton: false,
        //         timer: 5000,
        //         timerProgressBar: true,
        //         // didOpen: (toast) => {
        //         //   toast.addEventListener("mouseenter", Swal.stopTimer);
        //         //   toast.addEventListener("mouseleave", Swal.resumeTimer);
        //         // },
        //       });

        //       Toast.fire({
        //         icon: "info",
        //         title: "Data de Try-out do Molde",
        //         text: "Data menor do que a data de abertura do molde.",
        //       });

        //       return false;
        //     }
        //     return true;
        //   },
        // },

        // IGENF: {
        //   required,
        // },
        // IGFM: {
        //   required,
        // },
        // IGCMC: {
        //   required,
        // },
      },
    };
  },

  watch: {
    dados: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        const lista = this.dados;
        this.$emit("OBJ_Infor_Geral", lista);
      },
    },
    // "dados.IGMolde"(newValue) {
    //   const molde = this.listMoldes.find(
    //     (element) => element.VisResCode === newValue
    //   );
    // },
  },
  methods: {
    async mapMoldSap(molde) {
      const mold = molde.trim();

    const showToast = async (icon, title) => {
      const Toast = await this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({ icon, title });
    };

    if (!mold) {
      await showToast("error", "Digite um Molde");
      return;
    }

    try {

      const { data: moldeSap } = await sap.get(`/mold/`, {
        params: {
          unidade: "MAO",
          mold_code: molde,
        },
      });

      if (moldeSap.length === 0) {
        this.validationMolde = true;
        this.listMoldes = [];
        return;
      }

      this.validationMolde = false;
      this.listMoldes = moldeSap;
      this.$emit("mapMoldSap", moldeSap[0].cavidade);
    } catch (error) {
      console.error("Erro ao buscar molde:", error.message);
      await showToast("error", "Erro, molde não encontrado");
    }
    },
    ReformDate(date) {
      if (date === null) {
        return null;
      }
      const dataFormatada = dayjs(date).add(1, "days").format("YYYY-MM-DD");
      return dataFormatada;
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.InforGeral) {
        this.dados.IGDTM = this.ReformDate(
          dataQuery.InforGeral.DT_TRYOUT_MOLDE
        );
        this.dados.IGDAM = this.ReformDate(
          dataQuery.InforGeral.DT_ABERTURA_MOLDE
        );
        this.dados.IGDCM = this.ReformDate(
          dataQuery.InforGeral.DT_CHEGADA_MOLDE
        );
        this.dados.IGFM = dataQuery.InforGeral.FABRICANTE_MOLDE;
        this.dados.IGCMC = dataQuery.InforGeral.CODIGO_MOLDE;
        this.dados.molde_familia = dataQuery.InforGeral.molde_familia;
        this.dados.IGENF = this.ReformDate(dataQuery.InforGeral.EMISSAO);
        this.dados.IGNF = dataQuery.InforGeral.NOTA_FISCAL;

        this.dados.IGCliente = dataQuery.InforGeral.CLIENTE;
        this.dados.IGMolde = dataQuery.InforGeral.MOLDE;
        this.dados.IGRRIM = "RRIM-" + dataQuery.InforGeral.ID;
      }
    },
  },
};
</script>

<style scoped>
input:disabled {
  background: #66666621;
}

.m-40 {
  /* background: red; */
  width: 40%;
}

.m-20 {
  width: 33%;
}

.row-1 {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}
.flex {
  flex-direction: column;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: 0.8rem;
  line-height: 1.5;
}
.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderGreen);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}

.error {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background: var(--redTransparent);
  background-clip: padding-box;
  border: 1px solid var(--greyBtn);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.valid {
  border-color: var(--green);
  background: var(--white);
}

.valid:focus {
  outline-color: var(--green);
}

.checkbox {
  display: flex;
  gap: 0.7rem;
  align-items: center;
}

@media (max-width: 1226px) {
  .row-1 {
  flex-wrap: wrap!important;
}
}

@media (max-width: 1024px) {
  .m-20 {
    width: 31%;
  }

}

@media (max-width: 425px) {
  .row-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .row-1 div {
    width: 100%;
  }

  input {
    border: 1px solid var(--cinza);
    border-radius: 4px;
    background: var(--white);
    padding: 5px 10px;
  }
}
</style>
